import { useContext, useEffect } from 'react'
import ConsoleLogOverride from '../../actions/ConsoleLogOverride'
import useDeveloperOptionsActions from './useDeveloperOptionsActions'
import { AppContext, AppContextType } from '../../AppContext'
import { env } from '../../services/EnvironmentVariables'
import ElectronIPC from '../../services/ElectronIPC'
import { LOG_LEVEL_TABEL } from '../../services/Logger'

export default function useDeveloperOptionsService() {
    const { state: appState } = useContext(AppContext) as AppContextType

    const { setDeveloperMode } = useDeveloperOptionsActions()

    useEffect(() => {
        if (appState.appSettings.developerOptions.saveConfiguration) {
            setDeveloperMode(true)
        }
    }, [appState.appSettings.developerOptions.saveConfiguration])

    useEffect(() => {
        const opts = appState.appSettings.developerOptions

        if (typeof opts.enableAuditLogging === 'boolean') {
            env.ENABLE_AUDIT_LOGGING = opts.enableAuditLogging

            // also let the main thread know about this change.
            ElectronIPC.setEnvironmentVariables({
                ENABLE_AUDIT_LOGGING: env.ENABLE_AUDIT_LOGGING ? '1' : '',
            })
        }

        if (typeof opts.logLevel === 'string' && opts.logLevel !== '') {
            env.LOG_LEVEL = Number(opts.logLevel)

            if (env.LOG_LEVEL < LOG_LEVEL_TABEL['info']) {
                ConsoleLogOverride.disableConsoleLog()
            } else {
                ConsoleLogOverride.restoreDefaultConsoleLog()
            }
        }

        if (appState.appSettings.developerOptions.disableBlurEffect) {
            document.body.classList.add('disable-backdrop-blur')
        } else {
            document.body.classList.remove('disable-backdrop-blur')
        }

        // @ts-ignore
        window.env = env
    }, [appState.appSettings.developerOptions])
}
